<template>
	<div class="actset">
    <div style="margin-left: 10%;margin-top: 10%">
      <h1>功能更新维护中......</h1>
    </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				centre_id: '', //中心ID
				qrcode: '',
				token: ''
			}
		},
		filters: {

		},
		methods: {

		},
		mounted: function() {
			this.token = $.cookie('token')
		}

	}
</script>



// WEBPACK FOOTER //
// src/pages/qiandao/qiandao.vue